module.exports = __webpack_public_path__ + "static/img/c5.44dcb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c5.png
// module id = fXCz
// module chunks = 1